import { Api } from '../api';

import type { BusinessProduct } from '../types';

export class BusinessApi extends Api {

  public static async delete(businessId: number) {
    await super.remove(`/admin/business/${businessId}`);
  }

  public static async getProducts(id: number) {
    return this.get<BusinessProduct[]>(`/admin/business/${id}/products`);
  }

  public static async updateProduct(
    businessId: number, 
    productId: number, 
    data: { profit: number }
  ) {
    return this.patch<BusinessProduct[]>(`/admin/business/${businessId}/products/${productId}`, data);
  }
}
